import { render, staticRenderFns } from "./OnboardingQuestionEditSingle.vue?vue&type=template&id=5858eb72&"
import script from "./OnboardingQuestionEditSingle.vue?vue&type=script&lang=js&"
export * from "./OnboardingQuestionEditSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports